export const AUTH_COOKIE_NAME = 'portal.auth.v32';

export const AUTH_STATUS = {
  AUTHENTICATED: 'authenticated',
  NOT_AUTHENTICATED: 'not-authenticated',
} as const;
